import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { MarketronMapComponent } from '../marketron-map/marketron-map.component';
import { MapComponentService } from '../map/map.component.service';
import * as jQuery from 'jquery';
import { MAP_CONSTANTS, PRODUCT_NAMES } from '../../../analytics/constants/analytics.constants';
import * as M from 'mapbox-gl';
import * as _ from 'underscore';
import { AnalyticsDataChachingService } from '../../../analytics/services/analytics.datacaching.service';

@Component({
	providers: [MapComponentService],
	selector: 'app-r6-marketron-map',
	styleUrls: ['./r6-marketron-map.component.css'],
	templateUrl: './r6-marketron-map.component.html'
})
export class R6MarketronMapComponent extends MarketronMapComponent implements OnInit, AfterViewInit {
	@Input() uniqueoverwriteid: string;
	@Input() geofencegeovideocallattibutekey: any;
	public geoFenceCenterAddress: any;
	public onlyGeoFenceProductsSelected = false;
	public showGeofenceLegends: any;
	protected mapStyle = 'mapbox://styles/freq-e-deek/cjthqxn4m7z2e1fjp2rqqvxmp';
	protected mapFillColor = 'rgba(38, 94, 255, 0.25)';
	private isResized = false;

	/**
	 *
	 * @type {{productName: string; productKey: string; isDisabled: boolean; isSelected: boolean}[]}
	 */
	protected DEFAULT_PRODUCTS = [
		{
			productName: 'Display',
			productKey: MAP_CONSTANTS.STATE.DISPLAY,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasDisplay'],
			order: 2
		},
		{
			productName: 'Pre Roll',
			productKey: MAP_CONSTANTS.STATE.PREROLL,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasPreroll'],
			order: 3
		},
		{
			productName: 'SEM',
			productKey: MAP_CONSTANTS.STATE.SEM,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasSem'],
			order: 4
		},
		{
			productName: 'Connected TV',
			productKey: MAP_CONSTANTS.STATE.CTV,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasCtv'],
			order: 5
		},
		{
			productName: 'Streaming Audio',
			productKey: MAP_CONSTANTS.STATE.RADIO,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasRadio'],
			order: 5
		},
		{
			productName: 'GAM',
			productKey: MAP_CONSTANTS.STATE.GAM,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasGAM'],
			order: 6
		}
	];

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService,
		protected mapComponentService: MapComponentService,
		protected AnalyticsDataChachingService: AnalyticsDataChachingService
	) {
		super(analyticsService, analyticsDataModel, colorUtilityService, mapComponentService, AnalyticsDataChachingService);
		const colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.mapFillColor = this.colorUtilityService.getRGBByColorType(colorPalette, 'primary', 0.15);
		this.mapFillOutlineColor = this.colorUtilityService.getRGBByColorType(colorPalette, 'primary', 0.8);
		this.geoRecencyCircleColor = '#000000';
		this.geoRecencyCircleStrokeColor = '#FFFFFF';
		this.geoFenceCircleColor = '#FFFFFF';
		this.geoFenceStrokeColor = '#000000';
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.mapCoordinates['lng'] = this.partnerCountryLngLat['lng'] - 25;
		this.mapCoordinates['lat'] = this.partnerCountryLngLat['lat'];
		this.defaultMapZoom = 3.2;
		this.liftareacolor = '#FED351';
	}

	ngAfterViewInit(): void {
		super.ngAfterViewInit();
	}

	drawGeoFenceMarkers(geoFenceData, layerId, productName) {
		geoFenceData.features.forEach((marker) => {
			// create a DOM element for the marker
			const el = document.createElement('div');
			el.className = 'marker';
			el.style.backgroundImage = 'url(' + this.markericon + ')';
			el.style.width = 30 + 'px';
			el.style.height = 30 + 'px';
			el.addEventListener('click', (event) => {
				const centerPoint: any = [marker.properties.center_point_longitude, marker.properties.center_point_latitude];
				this.map.flyTo({
					center: centerPoint,
					zoom: 13,
					speed: 4
				});
			});
			// add marker to map
			const gfMarker: any = new M.Marker(el)
				.setLngLat([marker.properties.center_point_longitude, marker.properties.center_point_latitude])
				.addTo(this.map);

			el.addEventListener('mouseover', (event) => {
				const address = marker.properties.name;
				this.showGeoVideoCenterDetails(marker.properties);
				this.geoFenceCenterAddress = address;
			});

			el.addEventListener('mouseout', (event) => {
				this.hideGeofenceCenterDetails();
				jQuery('#info').css('opacity', 0);
			});

			if (PRODUCT_NAMES.GEOFENCE === productName) {
				this.geoFenceMarkers.push(gfMarker);
			} else if (PRODUCT_NAMES.GEOVIDEO === productName) {
				this.geoVideoMarkers.push(gfMarker);
			}
		});
	}

	showGeoVideoCenterDetails(geofenceCenterPoint) {
		clearTimeout(this.detailsTimeInterval);
		jQuery('.r6-map-details-container').css('display', 'block');
		if (geofenceCenterPoint.is_simplifi_restricted_geopoint) {
			jQuery('.geofence-disclaimer').css('display', 'block');
		}
		this.showGeofenceCenterDetailsFlag = true;
		this.geofenceCenterDetails = geofenceCenterPoint;
		this.geofenceCenterDetails.total_android = Math.round(
			(geofenceCenterPoint.android_impression_sum / geofenceCenterPoint.total_impression_sum) * 100
		);
		this.geofenceCenterDetails.total_ios = Math.round(
			(geofenceCenterPoint.ios_impression_sum / geofenceCenterPoint.total_impression_sum) * 100
		);
	}

	protected hideGeofenceCenterDetails() {
		this.detailsTimeInterval = setTimeout(() => {
			this.showGeofenceCenterDetailsFlag = false;
			jQuery('.r6-map-details-container').css('display', 'none');
			jQuery('.geofence-disclaimer').css('display', 'none');
		});
	}

	protected displayLocationDataOnMouseover(regionObj, e) {
		// jQuery('#info').css('display', 'block');
		// const content = `<div><strong> ${regionObj.city}, ${regionObj.local_id} </strong></div>`;
		// jQuery('#info').html(content);
		// const x = e.point.x;
		// const y = e.point.y;
		// const height = jQuery('#info').height();
		// const width = jQuery('#info').width();
		// const top = y - (height + 44);
		// const left = x - ((width / 2) - 20);
		// jQuery('#info').css('top', top);
		// jQuery('#info').css('left', left);
		// jQuery('#info').css('opacity', 1);
		if (!_.isEmpty(regionObj)) {
			this.polygonLayerDetails = {
				regionName: regionObj.city,
				region: regionObj.region,
				zip: regionObj.local_id,
				population: parseInt(regionObj.population).toLocaleString('en-IN'),
				zone: regionObj.zone ? regionObj.zone : regionObj.local_id
			};
			this.polygonLayerDetails['showLift'] = this.showLift(regionObj);

			if (regionObj.lift && this.polygonLayerDetails['showLift']) {
				this.polygonLayerDetails['avgLift'] =
					parseFloat(regionObj.lift.average_lift) > 0
						? parseFloat(regionObj.lift.average_lift) > 99
							? '> 99'
							: regionObj.lift.average_lift
						: '';
				this.polygonLayerDetails['avgHomeValue'] = regionObj.lift.avg_home_value;
				this.polygonLayerDetails['avgIncome'] = regionObj.lift.avg_income;
			}

			this.showPolygonLayerDetailsFlag = true;
		}
	}

	protected hideLocationDataOnMouseout() {
		this.showPolygonLayerDetailsFlag = false;
		// jQuery('#info').css('opacity', 0);
		this.polygonLayerDetails = {};
	}

	protected drawCenter() {
		if (this.selectedCombination && this.selectedCombination.center) {
			this.map.easeTo({
				center: this.selectedCombination.center,
				zoom: this.selectedCombination.zoomRange,
				duration: 0
			});
			jQuery('.no-data-map-overlay').remove();
			jQuery('.impression-gradient').css('display', 'flex');
		} else if (this.onlyGeoFenceProductsSelected) {
			const mapBounds = this.boundsForAvailableGeoFenceProducts;
			let zoomRange = this.get_bounds_zoom(mapBounds);
			// setting zoomRange to 12 to avoid the map to take original zoom level that is more ex: 21
			// this occurs when a particular campaign is selected with the default zoom range
			// Note: If zoom level > 12 then Satellite view will be enabled
			zoomRange = zoomRange > 12 ? 12 : zoomRange;
			if (this.selectedGeofenceProducts.length === this.GF_PRODUCTS.length) {
				this.drawGeoProductsMapBounds(mapBounds, zoomRange);
			} else if (
				this.selectedGeofenceProducts.length === 1 &&
				this.selectedGeofenceProducts[0] === PRODUCT_NAMES.GEOVIDEO
			) {
				this.geoVideoMarkers && this.geoVideoMarkers.length > 0
					? this.drawGeoProductsMapBounds(mapBounds, zoomRange)
					: this.setDefaultMap();
			} else if (this.selectedGeofenceProducts[0] === PRODUCT_NAMES.GEOFENCE) {
				this.geoFenceMarkers && this.geoFenceMarkers.length > 0
					? this.drawGeoProductsMapBounds(mapBounds, zoomRange)
					: this.setDefaultMap();
			}
			jQuery('.no-data-map-overlay').remove();
			jQuery('.impression-gradient').css('display', 'flex');
		} else {
			this.setDefaultMap();
		}
		setTimeout(() => {
			if (!this.isResized) {
				this.isResized = true;
				if (this.map) {
					this.map.resize();
				}
			}
		}, 200);
	}

	setDefaultMap() {
		if (
			jQuery('.mapboxgl-canvas').children().length == 0 &&
			!this.showLoad &&
			this.isR6 &&
			jQuery('.no-data-map-overlay').length <= 0
		) {
			jQuery('.impression-gradient').css('display', 'none');
			jQuery('.mapboxgl-canvas').after('<div class="no-data-map-overlay">Map Data is Not Available</div>');
		}
		this.map.easeTo({
			center: [this.mapCoordinates['lng'], this.mapCoordinates['lat']], // starting position [lng, lat]
			zoom: this.defaultMapZoom, // starting zoom
			duration: 0
		});
	}
}
